export default __webpack_public_path__ + "static/media/08.bb85cd2b.png";